import { createAction, props } from '@ngrx/store';


export const loadAuction = createAction(
    '[Campaign] Load Auction',
    props<any>()
);

export const loadAuctionSuccess = createAction(
    '[Campaign] Load Auction Success',
    props<{ data: any }>()
);

export const loadAuctionFailure = createAction(
    '[Campaign] Load Auction Failure',
    props<{ error: any }>()
);

export const saveCategory = createAction(
    '[Campaign] Save Category',
    props<{ data: any }>()
);

export const loadItemDetailInfo = createAction(
    '[Campaign] Load Item Detail Info',
    props<any>()
);


export const loadItemDetailInfoSuccess = createAction(
    '[Campaign] Load Item Detail Info Success',
    props<{ data: any }>()
);

export const loadItemDetailInfoFailure = createAction(
    '[Campaign] Load Item Detail Info Failure',
    props<{ error: any }>()
);

export const deleteBid = createAction(
    '[Campaign] Load DeleteBid',
    props<any>()
);

export const deleteBidSuccess = createAction(
    '[Campaign] Load DeleteBid Success',
    props<{ data: any }>()
);

export const deleteBidFailure = createAction(
    '[Campaign] Load DeleteBid Failure',
    props<{ error: any }>()
);

export const deleteAutoBid = createAction(
    '[Campaign] Load DeleteAutoBid',
    props<any>()
);

export const deleteAutoBidSuccess = createAction(
    '[Campaign] Load DeleteAutoBid Success',
    props<{ data: any }>()
);

export const deleteAutoBidFailure = createAction(
    '[Campaign] Load DeleteAutoBid Failure',
    props<{ error: any }>()
);

export const updateBidder = createAction(
    '[Campaign] Load UpdateBidder',
    props<any>()
);

export const updateBidderSuccess = createAction(
    '[Campaign] Load UpdateBidder Success',
    props<{ data: any }>()
);

export const updateBidderFailure = createAction(
    '[Campaign] Load UpdateBidder Failure',
    props<{ error: any }>()
);

export const loadBidActivy = createAction(
    '[Auction campgaign] Load bid activity',
    props<{campaignId: string, since: number}>()
)

export const loadBidActivySuccess = createAction(
    '[Auction campgaign] Load bid activity success',
    props<{bidActivityList: any[]}>()
)

export const loadBidActivyFailure = createAction(
    '[Auction campgaign] Load bid activity failure',
    props<{error: any}>()
)

export const loadPendingDonations = createAction(
    '[Acuction campaign] Load pending donations',
    props<{campaignId:string}>(),
)

export const loadPendingDonationsSuccess = createAction(
    '[Acuction campaign] Load pending donations success',
    props<{pendingDonations:any[]}>(),
)

export const loadPaidDonations = createAction(
    '[Acuction campaign] Load paid donations',
    props<{campaignId:string}>(),
)

export const loadPaidDonationsSuccess = createAction(
    '[Acuction campaign] Load paid donations success',
    props<{paidDonations:any[]}>(),
)